<template>
    <div class="ui-modal" :class="{ small }" @close="closeModal">
        <button
            v-if="canClose"
            @click="closeUiModal"
            class="ui-modal__close "
        >
            <span v-text="'×'" />
        </button>

        <div v-if="$slots.header" class="ui-modal__header">
            <slot name="header"/>
        </div>

        <div class="ui-modal__content">
            <slot />
        </div>

        <div v-if="$slots.footer" class="ui-modal__footer">
            <slot name="footer" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        canClose: { type: Boolean, default: true },
        small: { type: Boolean, default: false }
    },

    inject: ['closeModal'],

    methods: {
        closeUiModal() {
            this.closeModal()
        },

        onEscapeKey(event) {
            event.stopPropagation()
            event.preventDefault()
        }
    },

    mounted() {
        // if canClose is false, prevent escape key from closing the modal
        if (!this.canClose) {
            document.addEventListener('keydown', this.onEscapeKey)
        }
    },

    beforeUnmount() {
        document.removeEventListener('keydown', this.onEscapeKey)
    }
}
</script>

<style lang="scss">
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.ui-modal {
    --modal-width: 1100px;
    width: var(--modal-width);
    max-width: calc(100% - 2rem);
    max-height: calc(100% - 2rem);
    background-color: var(--color-white);
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &.small {
        --modal-width: 500px;
    }

    &__close {
        position: absolute;
        top: 5px;
        right: 9px;
        padding: 0;
        background-color: transparent;
        border: 0;
        outline: none;
        font-size: 2rem;
        color: var(--color-primary);
        line-height: 1;
    }

    &__header {
        padding: 20px;
        min-height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid var(--color-gray-200);
    }

    &__content {
        padding: 1rem;
        overflow-y: auto;
        flex: 1;
    }

    &__footer {
        --gap: 1rem;
        padding: 1rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        border-top: 1px solid var(--color-gray-200);
        background-color: var(--color-white);
        gap: var(--gap);

        > * {
            flex: 1;
            max-width: calc(var(--modal-width) / 2 - var(--gap));
        }
    }

    @include media-breakpoint-down(ms) {
        max-width: 100vw;
        max-height: 100vh;
    }
}
</style>